<div class="page-container">
  <cam-notification-box></cam-notification-box>

  <div class="page-content">
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
